import { useEffect } from "react";
import Lenis from "lenis";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Partners from "@/components/Partners";
import Services from "@/components/Services";
import Studio from "@/components/Studio";
import Process from "@/components/Process";
import Testimonials from "@/components/Testimonials";
import BriefForm from "@/components/BriefForm";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";

export default function Home() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="relative bg-white text-gray-900 overflow-x-clip">
      <Navbar />
      <main>
        <Hero />
        <Partners />
        <Services />
        <Studio />
        <Process />
        <Testimonials />
        <BriefForm />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
